import React, { useState } from "react";
import { Link } from "react-router-dom";
import AppsLauncherDropdown from "./AppsLauncherDropdown";
import ProfileDropdown from "./ProfileDropdown";
import indexxLogo from "../../../assets/header-icons/indexx-logo-v3-dark.svg";

interface NavbarProps {
  onLogout?: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({ onLogout }) => {
  const [isLauncherOpen, setIsLauncherOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const storedUser = localStorage.getItem("user") || localStorage.getItem("email");
  const userInitials = storedUser
    ? storedUser.slice(0, 2).toUpperCase()
    : "AV";

  const toggleLauncher = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsProfileOpen(false);
    setIsLauncherOpen((prev) => !prev);
  };

  const toggleProfile = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsLauncherOpen(false);
    setIsProfileOpen((prev) => !prev);
  };

  return (
    <header className="homepage1-nav-wrapper">
      <div className="homepage1-nav-container">
        {/* Brand Logo */}
        <Link to="/" className="homepage1-brand">
          <img
            src={indexxLogo}
            alt="indexx.ai"
            className="homepage1-brand-logo"
          />
        </Link>

        {/* Right Navigation Controls */}
        <div className="homepage1-nav-actions">
          {/* 9-Dots Apps Launcher Button & Dropdown */}
          <div className="relative">
            <button
              type="button"
              id="apps-launcher-btn"
              aria-label="Ecosystem Apps"
              className={`homepage1-launcher-btn ${isLauncherOpen ? "active" : ""}`}
              onClick={toggleLauncher}
              title="Google-Style 9-Dots Launcher"
            >
              <span className="material-symbols-outlined text-[20px]">
                apps
              </span>
            </button>
            <AppsLauncherDropdown
              isOpen={isLauncherOpen}
              onClose={() => setIsLauncherOpen(false)}
            />
          </div>

          {/* User Profile Avatar & Dropdown */}
          <div className="relative">
            <button
              type="button"
              id="profile-avatar-btn"
              aria-label="User Profile"
              className="homepage1-profile-btn"
              onClick={toggleProfile}
              title="Account Settings"
            >
              <div className="homepage1-profile-avatar-ring">
                <div className="homepage1-profile-avatar-inner">
                  <span className="homepage1-profile-avatar-initials">
                    {userInitials}
                  </span>
                </div>
              </div>
            </button>
            <ProfileDropdown
              isOpen={isProfileOpen}
              onClose={() => setIsProfileOpen(false)}
              onLogout={onLogout}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
